// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e81d8f93","411":"a86cef87","453":"d9e4023f","455":"6f0b01cf","880":"870cc030","977":"5855717c"}[chunkId] + ".chunk.js";
};